module.exports = __webpack_public_path__ + "img/icon.043e9b7a.png";